export * from './DocTextIcon';
export * from './DocTextIcon16Light';
export * from './DocTextIcon16Regular';
export * from './DocTextIcon16Solid';
export * from './DocTextIcon20Light';
export * from './DocTextIcon20Regular';
export * from './DocTextIcon20Solid';
export * from './DocTextIcon24Regular';
export * from './DocTextIcon24Solid';
export * from './DocTextIcon32Regular';
export * from './DocTextIcon64Regular';
